<template>
  <div class="wrapper" v-loading="reflesh">
    <div class="title">{{ realName }}</div>
    <div class="tip">此表为学校报名考试需要，与平台无关</div>
    <div class="form">
      <el-form :model="formData" :disabled="formDisabled" ref="form" label-position="top" label-width="80px" mode="horizontal">
        <div v-if="!reflesh">
          <div v-for="(item, index) in sendData" :key="index" class="form-item-container">
            <!-- 删除按钮 -->
            <div v-if="item.fieldType == 'time' && isShow(item)" class="info-form">
              <el-form-item>
                <template slot="label">
                  <span v-if="item.fieldParam.required" class="isRequired">*</span>{{ item.fieldName }}
                </template>
                <el-date-picker @click="chooseTime(index)" v-model="item.fieldContent" type="date" format="yyyy-MM-dd" clearable
                  value-format="yyyy-MM-dd" placeholder="请选择时间" :disabled="item.disabled"></el-date-picker>
              </el-form-item>
            </div>

            <div v-else-if="item.fieldType == 'period' && isShow(item)" class="info-form">
              <el-form-item>
                <template slot="label">
                  <span v-if="item.fieldParam.required" class="isRequired">*</span>{{ item.fieldName }}
                </template>
                <div style="margin-bottom: 10px">
                  <el-date-picker @click="handleShowPickerStart(index)" v-model="item.start" type="month" clearable
                    format="yyyy年MM月" value-format="yyyy年MM月" placeholder="请选择开始年月"></el-date-picker>
                </div>
                <div>
                  <el-date-picker @click="handleShowPickerEnd(index)" v-model="item.end" type="month" format="yyyy年MM月" clearable
                    value-format="yyyy年MM月" placeholder="请选择结束年月"></el-date-picker>
                </div>
              </el-form-item>
            </div>

            <div v-else-if="item.fieldType == 'address' && isShow(item)" class="info-form">
              <el-form-item>
                <template slot="label">
                  <span v-if="item.fieldParam.required" class="isRequired">*</span>{{ item.fieldName }}
                </template>
                <!-- 地址选择组件 -->
                <el-cascader style="width: 100%" v-model="item.fieldContent" clearable
                             popper-class="custom-address-popper"
                             :options="areaTree" :props="{
                  value: 'value',
                  label: 'label',
                  children: 'children',
                  expandTrigger: 'click'
                }" :disabled="item.disabled" placeholder="请选择地址" :loading="areaLoading"></el-cascader>
              </el-form-item>
            </div>

            <div v-else-if="item.fieldType == 'text' && isShow(item)" class="info-form">
              <el-form-item>
                <template slot="label">
                  <span v-if="item.fieldParam.required" class="isRequired">*</span>{{ item.fieldName }}
                </template>
                <template v-if="item.fieldParam.multiple">
                  <el-input clearable v-for="(field, j) in item.fieldContent" :key="j + 'field'" v-model="item.fieldContent[j]"
                    :placeholder="item.fieldName" style="margin-bottom: 10px" :maxlength="30" show-word-limit></el-input>
                </template>
                <el-input v-else v-model="item.fieldContent" :placeholder="item.fieldName" :maxlength="30" show-word-limit clearable></el-input>
              </el-form-item>
            </div>

            <div v-else-if="item.fieldType == 'email' && isShow(item)" class="info-form">
              <el-form-item>
                <template slot="label">
                  <span v-if="item.fieldParam.required" class="isRequired">*</span>{{ item.fieldName }}
                </template>
                <el-input v-model.trim="item.fieldContent" :placeholder="item.fieldName" clearable></el-input>
              </el-form-item>
            </div>

            <div v-else-if="item.fieldType == 'tel' && isShow(item)" class="info-form">
              <el-form-item>
                <template slot="label">
                  <span v-if="item.fieldParam.required" class="isRequired">*</span>{{ item.fieldName }}
                </template>
                <el-input type="tel" v-model="item.fieldContent" clearable></el-input>
              </el-form-item>
            </div>

            <div v-else-if="item.fieldType == 'textarea' && isShow(item)" class="info-form">
              <el-form-item>
                <template slot="label">
                  <span v-if="item.fieldParam.required" class="isRequired">*</span>{{ item.fieldName }}
                </template>
                <el-input show-word-limit :maxlength="item.fieldParam.maxlength ? item.fieldParam.maxlength : 10000"
                  rows="5" type="textarea" v-model="item.fieldContent" :placeholder="item.fieldName" clearable></el-input>
              </el-form-item>
            </div>

            <div v-else-if="item.fieldType == 'radio' && isShow(item)" class="info-form">
              <el-form-item>
                <template slot="label">
                  <span v-if="item.fieldParam.required" class="isRequired">*</span>{{ item.fieldName }}
                </template>
                <el-radio-group v-model="item.fieldContent">
                  <el-radio v-for="op in item.fieldParam.list" :label="op" :key="op">{{ op }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>

            <div v-else-if="item.fieldType == 'checkbox' && isShow(item)" class="info-form">
              <el-form-item>
                <template slot="label">
                  <span v-if="item.fieldParam.required" class="isRequired">*</span>{{ item.fieldName }}
                </template>
                <el-checkbox-group :max="item.fieldParam.max || item.fieldParam.list.length"
                  v-model="item.fieldContent">
                  <el-checkbox v-for="op in item.fieldParam.list" :label="op" :key="op">{{ op }}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </div>

            <div v-else-if="item.fieldType == 'picker' && isShow(item)" class="info-form">
              <el-form-item>
                <template slot="label">
                  <span v-if="item.fieldParam.required" class="isRequired">*</span>{{ item.fieldName }}
                </template>
                <el-select v-model="item.fieldContent" placeholder="请选择" clearable>
                  <el-option v-for="op in item.fieldParam.list" :key="op" :label="op + ''" :value="op"></el-option>
                </el-select>
              </el-form-item>
            </div>

            <div v-else-if="item.fieldType == 'uploadImg' && isShow(item)" class="info-form">
              <el-form-item>
                <template slot="label">
                  <span v-if="item.fieldParam.required" class="isRequired">*</span>{{ item.fieldName }}
                </template>
                <div v-if="item.uploadParam.tip">
                  {{ item.uploadParam.tip }}
                </div>
                <p class="color1" style="margin-bottom: 10px">
                  上传图片每张大小限制{{ item.uploadParam.maxSize }}M以内，限制图片格式：JPG或者PNG
                </p>
                <el-upload list-type="picture-card" :on-preview="(file) => handlePictureCardPreview(file, index)" action
                  :before-upload="(file) => beforUpload(file, item)"
                  :before-remove="(file, fileList) => handleBeforeRemove(file, fileList, index)"
                  :on-remove="(file, fileList) => handleRemove(file, fileList, index)" :accept="item.uploadParam.accept"
                  :file-list="item.uploadParam.fileList" :limit="item.uploadParam.maxCount || 100"
                  :on-exceed="() => onExceed(item.uploadParam.maxCount)"
                  :http-request="(file) => customUpload(file, index)"
                  :on-change="(file, fileList) => handleChange(file, fileList, index)"
                  :on-success="() => handleUploadSuccess(index)"
                  :class="{ 'hide-upload-btn': item.uploadParam.fileList.length >= (item.uploadParam.maxCount || 100) }">
                  <i class="el-icon-plus"></i>
                </el-upload>
              </el-form-item>
            </div>

            <div v-else-if="item.fieldType == 'uploadVideo' && isShow(item)" class="info-form">
              <el-form-item>
                <template slot="label">
                  <span v-if="item.fieldParam.required" class="isRequired">*</span>{{ item.fieldName }}
                </template>
                <div v-if="item.uploadParam.tip">
                  {{ item.uploadParam.tip }}
                </div>
                <p class="color1" style="margin-bottom: 10px">
                  上传视频每部应小于{{ item.uploadParam.maxSize }}M，视频格式为：mp4/mov
                </p>
                <el-upload action :on-preview="(file) => handleFilePreview(file, index)"
                  :before-upload="(file) => beforUpload(file, item)"
                  :before-remove="(file, fileList) => handleBeforeRemove(file, fileList, index)"
                  :on-remove="(file, fileList) => handleRemove(file, fileList, index)" :accept="item.uploadParam.accept"
                  :file-list="item.uploadParam.fileList" :limit="item.uploadParam.maxCount || 100"
                  :on-exceed="() => onExceed(item.uploadParam.maxCount)"
                  :http-request="(file) => customUpload(file, index)"
                  :on-change="(file, fileList) => handleChange(file, fileList, index)"
                  :on-success="() => handleUploadSuccess(index)"
                  :class="{ 'hide-upload-btn': item.uploadParam.fileList.length >= (item.uploadParam.maxCount || 100) }">
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </el-form-item>
            </div>

            <div v-else-if="item.fieldType == 'uploadPDF' && isShow(item)" class="info-form">
              <el-form-item>
                <template slot="label">
                  <span v-if="item.fieldParam.required" class="isRequired">*</span>{{ item.fieldName }}
                </template>
                <div v-if="item.uploadParam.tip">
                  {{ item.uploadParam.tip }}
                </div>
                <p class="color1" style="margin-bottom: 10px">
                  上传pdf应小于{{ item.uploadParam.maxSize }}M，pdf格式为：pdf
                </p>
                <el-upload action :on-preview="(file) => handleFilePreview(file, index)"
                  :before-upload="(file) => beforUpload(file, item)"
                  :before-remove="(file, fileList) => handleBeforeRemove(file, fileList, index)"
                  :on-remove="(file, fileList) => handleRemove(file, fileList, index)" :accept="item.uploadParam.accept"
                  :file-list="item.uploadParam.fileList" :limit="item.uploadParam.maxCount || 100"
                  :on-exceed="() => onExceed(item.uploadParam.maxCount)"
                  :http-request="(file) => customUpload(file, index)"
                  :on-change="(file, fileList) => handleChange(file, fileList, index)"
                  :on-success="() => handleUploadSuccess(index)"
                  :class="{ 'hide-upload-btn': item.uploadParam.fileList.length >= (item.uploadParam.maxCount || 100) }">
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </el-form-item>
            </div>

            <div v-else-if="item.fieldType == 'uploadAudio' && isShow(item)" class="info-form">
              <el-form-item>
                <template slot="label">
                  <span v-if="item.fieldParam.required" class="isRequired">*</span>{{ item.fieldName }}
                </template>
                <div v-if="item.uploadParam.tip">
                  {{ item.uploadParam.tip }}
                </div>
                <p class="color1" style="margin-bottom: 10px">
                  上传音频应小于{{ item.uploadParam.maxSize }}M，音频格式为：mp3
                </p>
                <el-upload action :on-preview="(file) => handleFilePreview(file, index)"
                  :before-upload="(file) => beforUpload(file, item)"
                  :before-remove="(file, fileList) => handleBeforeRemove(file, fileList, index)"
                  :on-remove="(file, fileList) => handleRemove(file, fileList, index)" :accept="item.uploadParam.accept"
                  :file-list="item.uploadParam.fileList" :limit="item.uploadParam.maxCount || 100"
                  :on-exceed="() => onExceed(item.uploadParam.maxCount)"
                  :http-request="(file) => customUpload(file, index)"
                  :on-change="(file, fileList) => handleChange(file, fileList, index)"
                  :on-success="() => handleUploadSuccess(index)"
                  :class="{ 'hide-upload-btn': item.uploadParam.fileList.length >= (item.uploadParam.maxCount || 100) }">
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </el-form-item>
            </div>

            <div v-else-if="item.fieldType == 'personInfo' && isShow(item)" class="info-form" :key="item.fieldId">
              <div v-if="['收件人手机号', '联系人手机号'].includes(item.fieldName)" class="info-form">
                <el-form-item :prop="`field_${item.fieldId}`" :rules="[
                  {
                    validator: validatorPhone,
                    message: '请输入正确手机号',
                    required: item.fieldParam.required ? true : false,
                  }
                ]">
                  <template slot="label">
                    <span v-if="item.fieldParam.required" class="isRequired"></span>{{ item.fieldName }}
                  </template>
                  <el-input type="tel" v-model="formData[`field_${item.fieldId}`]" placeholder="请输入" clearable></el-input>
                </el-form-item>
              </div>
              <div v-else-if="['考生号'].includes(item.fieldName)" class="info-form">
                <el-form-item :prop="`field_${item.fieldId}`" :rules="[
                  {
                    validator: validator1to18,
                    message: '18位以内纯数字',
                    required: item.fieldParam.required ? true : false,
                  }
                ]">
                  <template slot="label">
                    <span v-if="item.fieldParam.required" class="isRequired"></span>{{ item.fieldName }}
                  </template>
                  <el-input type="tel" v-model="formData[`field_${item.fieldId}`]" placeholder="请输入" clearable></el-input>
                </el-form-item>
              </div>
              <div v-else-if="['身高'].includes(item.fieldName)" class="info-form">
                <el-form-item :prop="`field_${item.fieldId}`" :rules="[
                  {
                    validator: validator50to300,
                    message: '50-300的数字',
                    required: item.fieldParam.required ? true : false,
                  }
                ]">
                  <template slot="label">
                    <span v-if="item.fieldParam.required" class="isRequired"></span>{{ item.fieldName }}
                  </template>
                  <el-input type="tel" v-model="formData[`field_${item.fieldId}`]" placeholder="请输入" clearable>
                    <template slot="append">cm</template>
                  </el-input>
                </el-form-item>
              </div>
              <div v-else-if="['体重'].includes(item.fieldName)" class="info-form">
                <el-form-item :prop="`field_${item.fieldId}`" :rules="[
                  {
                    validator: validator1to999,
                    message: '1-999的数字',
                    required: item.fieldParam.required ? true : false,
                  }
                ]">
                  <template slot="label">
                    <span v-if="item.fieldParam.required" class="isRequired"></span>{{ item.fieldName }}
                  </template>
                  <el-input type="tel" v-model="formData[`field_${item.fieldId}`]" placeholder="请输入" clearable>
                    <template slot="append">kg</template>
                  </el-input>
                </el-form-item>
              </div>
              <div v-else-if="['毕业中学', '收件人', '联系人', '姓名', '证件号码', '联系方式'].includes(item.fieldName)" class="info-form">
                <el-form-item>
                  <template slot="label">
                    <span v-if="item.fieldParam.required" class="isRequired">*</span>{{ item.fieldName }}
                  </template>
                  <el-input maxlength="50" :disabled="item.disabled" v-model="item.fieldContent"
                    placeholder="请输入" clearable show-word-limit></el-input>
                </el-form-item>
              </div>
              <div v-else-if="['通信街道详情'].includes(item.fieldName)" class="info-form">
                <el-form-item>
                  <template slot="label">
                    <span v-if="item.fieldParam.required" class="isRequired">*</span>{{ item.fieldName }}
                  </template>
                  <el-input maxlength="200" v-model="item.fieldContent" placeholder="请输入" clearable show-word-limit></el-input>
                </el-form-item>
              </div>
              <div v-else-if="['报名省份', '性别', '证件类型'].includes(item.fieldName)" class="info-form">
                <el-form-item>
                  <template slot="label">
                    <span v-if="item.fieldParam.required" class="isRequired">*</span>{{ item.fieldName }}
                  </template>
                  <el-select v-model="item.fieldContent" placeholder="请选择" :disabled="item.disabled" clearable>
                    <el-option v-for="(op, index) in getOptionList(item.fieldName)" :key="op + index + ''" :label="op"
                      :value="op"></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div v-else-if="['科类'].includes(item.fieldName)" class="info-form">
                <el-form-item>
                  <template slot="label">
                    <span v-if="item.fieldParam.required" class="isRequired">*</span>{{ item.fieldName }}
                  </template>
                  <el-dialog v-model="item.fieldParam.showPicker" title="选择科类" width="30%">
                    <el-select v-model="item.fieldContent" placeholder="请选择科类" style="width: 100%"
                      @change="item.fieldParam.showPicker = false" clearable>
                      <el-option v-for="op in subjectTypeList" :key="op" :label="op" :value="op"></el-option>
                    </el-select>
                    <span slot="footer" class="dialog-footer">
                      <el-button @click="item.fieldParam.showPicker = false">取消</el-button>
                      <el-button type="primary" @click="item.fieldParam.showPicker = false">确定</el-button>
                    </span>
                  </el-dialog>
                  <el-input v-if="item.disabled" :disabled="item.disabled" v-model="item.fieldContent"
                    placeholder="请选择科类" readonly />
                  <el-input v-else v-model="item.fieldContent" placeholder="请选择科类" readonly
                    @click.native="item.fieldParam.showPicker = true" />
                </el-form-item>
              </div>
              <div v-else-if="['艺考证', '一寸免冠照'].includes(item.fieldName)" class="info-form">
                <el-form-item>
                  <template slot="label">
                    <span v-if="item.fieldParam.required" class="isRequired">*</span>{{ item.fieldName }}
                  </template>
                  <p class="color1" style="margin-bottom: 10px">
                    上传图片每张大小限制10M以内，限制图片格式：JPG、PNG、JPEG
                  </p>
                  <div>
                    <!-- 显示已上传的文件 -->
                    <!-- <div v-for="(file, fileIndex) in item.uploadParam.fileList" :key="file.uid"
                      class="el-upload-list__item el-upload-list__item--picture-card" style="max-width: 100px;">
                      <img :src="file.url" alt="" class="el-upload-list__item-thumbnail" style="max-width: 100px;">
                      <div class="el-upload-list__item-actions" style="cursor: pointer;">
                        <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file, index)">
                          <i class="el-icon-zoom-in"></i>
                        </span>
                        <span style="margin-left: 20px;"
                          @click="handleRemove(file, item.uploadParam.fileList, index, fileIndex)">
                          <i class="el-icon-delete"></i>
                        </span>
                      </div>
                    </div> -->
                    <!-- 上传按钮 -->
                    <el-upload list-type="picture-card"
                      :on-preview="(file) => handlePictureCardPreview(file, index)" action
                      :before-upload="(file) => beforUpload(file, item)"
                      :before-remove="(file, fileList) => handleBeforeRemove(file, fileList, index)"
                      :on-remove="(file, fileList) => handleRemove(file, fileList, index)" accept=".jpg,.jpeg,.png"
                      :file-list="item.uploadParam.fileList" :limit="1"
                      :on-exceed="(file, fileList) => handleExceed(file, fileList)"
                      :http-request="(file) => customUpload(file, index)"
                      :on-change="(file, fileList) => handleChange(file, fileList, index)"
                      :on-success="() => handleUploadSuccess(index)"
                      :class="{ 'hide-upload-btn': item.uploadParam.fileList.length >= 1 }">
                      <template>
                        <i class="el-icon-plus"></i>
                      </template>
                    </el-upload>
                  </div>
                </el-form-item>
              </div>
              <div v-else-if="['通信地址'].includes(item.fieldName)" class="info-form">
                <el-form-item>
                  <template slot="label">
                    <span v-if="item.fieldParam.required" class="isRequired">*</span>{{ item.fieldName }}
                  </template>
                  <!-- 地址选择组件，最多显示2层 -->
                  <el-cascader style="width: 100%" v-model="item.fieldContent" clearable :options="twoLevelAreaTree" :props="{
                    value: 'value',
                    label: 'label',
                    children: 'children',
                    expandTrigger: 'click'
                  }" :disabled="item.disabled" placeholder="请选择地址" :loading="areaLoading"></el-cascader>
                </el-form-item>
              </div>
              <div v-if="['出生年月'].includes(item.fieldName) && isShow(item)" class="info-form">
                <el-form-item>
                  <template slot="label">
                    <span v-if="item.fieldParam.required" class="isRequired">*</span>{{ item.fieldName }}
                  </template>
                  <el-date-picker v-model="item.fieldContent" type="date" format="yyyy-MM-dd" value-format="yyyyMMdd"
                    placeholder="请选择年月" :disabled="item.disabled" clearable></el-date-picker>
                </el-form-item>
              </div>
            </div>

            <div v-else-if="item.fieldType == 'subjectInfo' && isShow(item)" class="info-form">
              <el-form-item>
                <template slot="label">
                  <span v-if="item.fieldParam.required" class="isRequired">*</span>{{ item.fieldName }}
                </template>
                <div style="margin-bottom: 10px">
                  <el-input v-model="item.fieldProvinceName" placeholder="高考省份" :disabled="true"
                    style="width: 100%" clearable></el-input>
                </div>
                <div v-if="!['港澳台侨', '国际'].includes(item.fieldProvinceName)" style="margin-bottom: 10px">
                  <el-select v-model="item.fieldSubjectName" placeholder="省统考科类" @change="chooseSubject(index, 1)"
                    style="width: 100%" clearable>
                    <el-option v-for="op in item.fieldParam.subjectList" :key="op" :label="op" :value="op"></el-option>
                  </el-select>
                </div>
                <div v-if="!['港澳台侨', '国际'].includes(item.fieldProvinceName)">
                  <el-select v-model="item.fieldSubSubjectName" placeholder="省统考子科类" style="width: 100%" clearable>
                    <el-option v-for="op in item.fieldParam.subSubjectList" :key="op" :label="op"
                      :value="op"></el-option>
                  </el-select>
                </div>
              </el-form-item>
            </div>

            <div v-else-if="item.fieldType == 'attachment' && isShow(item)" class="info-form">
              <el-form-item>
                <template slot="label">
                  <span v-if="item.fieldParam.required" class="isRequired">*</span>{{ item.fieldName }}
                </template>
                <div @click="downloadAttachment(item, index)" class="downloadAttachment">
                  {{ item.attachmentName }}
                  <span style="cursor: pointer; color: #1890ff" class="downloadBtn">{{ item.downloadStatus == 1 ? '已下载' : '下载' }}</span>
                </div>
              </el-form-item>
            </div>
          </div>
        </div>
      </el-form>

      <el-dialog :visible.sync="previewImageVisible">
        <img width="100%" :src="previewImageUrl" alt="" />
      </el-dialog>

      <el-dialog :visible.sync="showVideo" width="80%">
        <video id="example_video_1" class="video-js vjs-default-skin vjs-big-play-centered" controls width="100%"
          height="400">
          <source :src="videoCurrent.src" type="video/mp4" />
        </video>
      </el-dialog>

      <el-dialog :visible.sync="showAudio" width="60%">
        <audio id="audio" controls style="width: 100%">
          <source :src="audioCurrent.src" type="audio/mpeg" />
        </audio>
      </el-dialog>
    </div>
    <div class="bottom">
      <el-button class="btn" :disabled="formDisabled" type="primary" @click="onSubmit" round>
        提交
      </el-button>
    </div>
  </div>
</template>

<script>
import {
  getRealUrl,
  multipartUploadFile,
} from '../services/aliOss'
import { getFormInfo, submitForm, getUserInfoByToken, getVarietyList, getAreaTree, getAreaList, getCityAreaList } from '../services/api'
import { fileNamebyUrl } from '@/utils/common'

export default {
  name: 'InfoForm',

  async created() {
    const { formConfigId, platform, from } = this.$route.query
    this.formConfigId = formConfigId
    this.platform = platform
    this.from = from
    window.vm = this
  },

  async mounted() {
    this.reflesh = true;
    await this.getCurrentUserInfo()
    await this.getData()
    // await this.getVarietyList()
    await this.getAreaTree() // 先获取地址树数据，再处理回显
    await this.getmsgInfo()
  },

  data() {
    return {
      from: null,
      formJson: {},
      previewImageUrl: '',
      previewImageVisible: false,
      areaTree: [],
      twoLevelAreaTree: [],
      areaLoading: false,
      collegeId: '',
      collegeName: '',
      formName: null,
      formId: '',
      formConfigId: '',
      confirmVisible: false,
      platform: '',
      isModifiable: 0,
      removeFile: { fieldId: null, index: -1 },
      // 文本：text ， 复选：checkbox ，电话：tel ，下拉：picker ，上传：uploadImg,uploadVideo,uploadAudio
      sendData: [],
      formData: {}, // 用于表单校验的model对象
      showVideo: false,
      showAudio: false,
      videoCurrent: { src: '' },
      audioCurrent: { src: '' },
      reflesh: false,
      disabled1: false,
      minDate: new Date(1900, 1, 1),
      minMonthDate: new Date(1950, 0, 1),
      maxMonthDate: new Date(2050, 0, 1),
      collegeJson: {},
      isAuditFieldValid: 0,
      personArr: [
        { value: "0", label: "艺考证" },
        { value: "1", label: "报名省份" },
        { value: "2", label: "考生号" },
        { value: "3", label: "科类" },
        { value: "4", label: "毕业中学" },
        { value: "5", label: "一寸免冠照" },
        { value: "6", label: "身高" },
        { value: "7", label: "体重" },
        { value: "8", label: "通信地址" },
        { value: "9", label: "通信街道详情" },
        { value: "10", label: "收件人" },
        { value: "11", label: "收件人手机号" },
        { value: "12", label: "联系人" },
        { value: "13", label: "联系人手机号" },
        { value: "14", label: "姓名" },
        { value: "15", label: "性别" },
        { value: "16", label: "出生年月" },
        { value: "17", label: "证件类型" },
        { value: "18", label: "证件号码" },
        { value: "19", label: "联系方式" },
      ],
      provinceList: [],
      subjectTypeList: ["历史类(文史)", "物理类(理工)", "综合类"],
      iDTypeList: ["身份证", "护照", "通行证"],
      sexTypeList: ["男", "女"],
      varietyList: [],
      relateList: [],
      userInfo: undefined
    }
  },

  computed: {
    isPc() {
      return this.platform === 'pc'
    },
    realName() {
      if (this.formName) {
        return this.formName
      } else {
        return this.collegeName + '学生信息表'
      }
    },

    formDisabled() {
      return !this.isModifiable
    },
  },

  filters: {
    fileTips: function (item) {
      const { fieldType } = item
      const { maxCount, tip, accept, maxSize } = item.uploadParam

      let finalTip = tip + '   '

      const tips = []

      let format = '文件格式：'
      if (fieldType == 'uploadImg') {
        format += 'JPG/PNG'
      } else if (fieldType == 'uploadVideo') {
        format += 'MP4'
      } else if (fieldType == 'uploadPDF') {
        format += 'PDF'
      } else if (fieldType == 'uploadAudio') {
        format += 'MP3'
      } else if (accept) {
        format += `accept.replace(/\./g, '')`
      }

      tips.push(format)

      if (maxCount) {
        tips.push(`数量限制：${maxCount}`)
      }

      if (maxSize) {
        tips.push(`大小限制：${maxSize}MB`)
      }

      finalTip += tips.join(`,  `)

      return finalTip
    },
  },

  methods: {
    // 判断是否显示当前控件
    isShow(val) {
      let isShow = true
      if (this.relateList?.length) {
        // 检查是否有依赖关系
        this.relateList.forEach((r) => {
          if (r.relatedFieldIdList.includes(val.fieldId)) {
            // 判断上次的内容值是否存在，并且值相同
            let tem = this.sendData.filter((d) => d.fieldId == r.originFieldId)
            // 如果内容不存在或者不相同就不显示
            if (
              tem &&
              (!tem[0].fieldContent
                || (tem[0].fieldType === 'checkbox' && !tem[0].fieldContent.includes(r.relatedContent) || tem[0].fieldType !== 'checkbox' && tem[0].fieldContent != r.relatedContent))
            ) {
              isShow = false
            } else if (tem && tem[0].fieldContent) {
              // 如果当前依赖项满足条件，还需要检查依赖项本身是否被显示
              if (!this.isShow(tem[0])) {
                isShow = false
              }
            }
          }
        })
      }
      return isShow
    },

    // 获取下拉选项列表
    getOptionList(fieldName) {
      if (fieldName === '报名省份') {
        const provinceList = this.provinceList.map((d) => {
          return d.areaName;
        });
        return provinceList
      } else if (fieldName === '科类') {
        return this.subjectTypeList
      } else if (fieldName === '性别') {
        return this.sexTypeList
      } else if (fieldName === '证件类型') {
        return this.iDTypeList
      }
      return []
    },

    // 时间选择
    chooseTime(index) {
      if (!this.sendData[index].fieldContent) {
        this.sendData[index].fieldContent = new Date(2020, 5, 15)
      }
    },

    handleShowPickerStart(index) {
      if (!this.sendData[index].start) {
        this.sendData[index].start = new Date(2018, 5, 15)
      }
    },

    handleShowPickerEnd(index) {
      if (!this.sendData[index].end) {
        this.sendData[index].end = new Date(2018, 5, 15)
      }
    },

    // 学科选择
    chooseSubject(index, jndex) {
      const data = this.varietyList
      this.sendData[index].fieldParam.list = []
      this.sendData[index].fieldParam.showPicker = true
      this.sendData[index].currentStep = jndex
      // 科类个人信息前端动态过滤数据，获取当前下拉组件的数据
      if (jndex == 0) {
        this.sendData[index].fieldParam.subjectList = []
        this.sendData[index].fieldParam.subSubjectList = []
        this.sendData[index].fieldParam.provinceList = data.map((p) => {
          return p.name
        })
      } else if (jndex == 1) {
        let subjectList = data.filter((p) => {
          return p.name == this.sendData[index].fieldProvinceName
        })
        if (subjectList && subjectList[0] && subjectList[0].subList) {
          this.sendData[index].fieldParam.subjectList = subjectList[0].subList.map((p) => {
            return p.name
          })
        } else {
          this.sendData[index].fieldParam.subjectList = []
        }
        // 清空第三级下拉框的内容
        this.sendData[index].fieldSubSubjectName = ''
        this.sendData[index].fieldParam.subSubjectList = []
        // 初始化第三级学科下拉框数据
        this.chooseSubject(index, 2)
      } else if (jndex == 2) {
        let subjectList = data.filter((p) => {
          return p.name == this.sendData[index].fieldProvinceName
        })
        if (subjectList && subjectList[0] && subjectList[0].subList) {
          let subChildList = subjectList[0].subList.filter((p) => {
            return p.name == this.sendData[index].fieldSubjectName
          })
          if (subChildList && subChildList[0] && subChildList[0].subList) {
            this.sendData[index].fieldParam.subSubjectList = subChildList[0].subList.map((p) => {
              return p.name
            })
          } else {
            this.sendData[index].fieldParam.subSubjectList = []
          }
        } else {
          this.sendData[index].fieldParam.subSubjectList = []
        }
      }
    },

    // 学科选择确认
    onConfirmSubject(index) {
      const value = this.sendData[index].tempValue
      if (this.sendData[index].currentStep == 0) {
        this.sendData[index].fieldSubjectName = ""
        this.sendData[index].fieldSubSubjectName = ""
        this.sendData[index].fieldProvinceName = value
      } else if (this.sendData[index].currentStep == 1) {
        this.sendData[index].fieldSubSubjectName = ""
        this.sendData[index].fieldSubjectName = value
      } else if (this.sendData[index].currentStep == 2) {
        this.sendData[index].fieldSubSubjectName = value
      }
      this.sendData[index].fieldContent = value
      this.sendData[index].fieldParam.showPicker = false
    },

    // 文件预览
    async handleFilePreview(file, index) {
      const url = file.url
      if (url) {
        const fullPath = url
        if (this.sendData[index].fieldType === 'uploadVideo') {
          this.showVideo = true
          this.videoCurrent.src = fullPath
        } else if (this.sendData[index].fieldType === 'uploadAudio') {
          this.showAudio = true
          this.audioCurrent.src = fullPath
        }
      }
    },

    handlePictureCardPreview(file, index) {
      this.previewImageUrl = file.url
      this.previewImageVisible = true
    },

    onCloseVideo() {
      this.showVideo = false
      if (this.videoCurrent) {
        this.videoCurrent.pause()
      }
    },

    onCloseAudio() {
      this.showAudio = false
      if (this.audioCurrent) {
        this.audioCurrent.pause()
      }
    },

    // 文件上传相关
    onExceed(max) {
      this.$message.warning(`最多只能上传${max}个文件`)
    },

    handleExceed(file, fileList) {
      this.$message.warning('最多只能上传1个文件')
    },

    handleUploadSuccess(index) {
      // 清除验证
    },

    handleBeforeRemove(file, fileList, index) {
      this.removeFile.index = fileList.findIndex(v => v.uid === file.uid)
      this.removeFile.fieldId = index
    },

    handleRemove(file, fileList, index, fileIndex) {
      if (fileIndex !== undefined) {
        // 直接删除文件
        this.sendData[index].imgUrl.splice(fileIndex, 1)
        this.sendData[index].uploadParam.fileList = fileList.filter((_, i) => i !== fileIndex)
      } else if (this.removeFile.fieldId === index) {
        // 通过removeFile对象删除文件
        this.sendData[index].imgUrl.splice(this.removeFile.index, 1)
        this.sendData[index].uploadParam.fileList = fileList
        this.removeFile = { fieldId: null, index: -1 }
      }
    },

    handleChange(file, fileList, index) {
      this.sendData[index].uploadParam.fileList = fileList
    },

    beforUpload(file, info) {
      const { fieldType, uploadParam } = info

      if (uploadParam.maxSize) {
        const filesizeInMB = file.size / 1024 / 1024
        if (filesizeInMB > uploadParam.maxSize) {
          this.$message.error(`文件大小不能超过${uploadParam.maxSize}M`)
          return false
        }
      }
      if (file.size <= 0) {
        this.$message.error(`文件大小为0，请检查上传文件！`)
        return false
      }

      if (fieldType === 'uploadAudio') {
        if (!['audio/mpeg', 'audio/mp3'].includes(file.type)) {
          this.$message.error('请上传mp3文件')
          return false
        }
      }

      if (fieldType === 'uploadPDF') {
        if (!['application/pdf'].includes(file.type)) {
          this.$message.error('请上传pdf文件')
          return false
        }
      }

      if (fieldType === 'uploadImg') {
        if (!['image/jpeg', 'image/jpg', 'image/png'].includes(file.type)) {
          this.$message.error('请上传 jpg 或者 png 格式图片')
          return false
        }
      }

      if (fieldType === 'uploadVideo') {
        if (!['video/mp4', 'video/mov', 'video/quicktime'].includes(file.type)) {
          this.$message.error('请上传 mp4 或者 mov 格式')
          return false
        }
      }
      return true
    },

    async customUpload(file, index) {
      const collegeId = this.collegeId
      const dir = `upload-file/${collegeId}`

      try {
        this.disabled1 = true
        file.status = 'uploading'
        file.message = '上传中...'
        const res = await multipartUploadFile(
          file.file,
          dir,
          '*',
          file.onProgress,
          file.onSuccess,
        )
        // 保存ossPath到imgUrl中，用于接口提交
        this.sendData[index].imgUrl.push(res.ossPath)

        file.status = 'done'
        file.message = '上传成功'

        this.disabled1 = false
      } catch (error) {
        this.disabled1 = false
        file.status = 'failed'
        file.message = '上传失败'
      }
    },

    // 附件下载
    async downloadAttachment(item, index) {
      if (item.attachmentUrl) {
        try {
          const fullPath = await getRealUrl(item.attachmentUrl)

          // 使用fetch API获取文件内容，然后创建Blob对象强制下载
          const response = await fetch(fullPath)
          if (!response.ok) {
            throw new Error('网络响应错误')
          }

          const blob = await response.blob()
          const url = URL.createObjectURL(blob)

          // 从URL中提取文件名
          const fileName = item.attachmentUrl.substring(item.attachmentUrl.lastIndexOf('/') + 1)

          // 创建a标签并触发下载
          const link = document.createElement('a')
          link.href = url
          link.download = fileName
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)

          // 释放URL对象
          setTimeout(() => {
            URL.revokeObjectURL(url)
          }, 100)

          this.sendData[index].downloadStatus = 1
        } catch (error) {
          console.error('下载失败:', error)
          this.$message.error('下载失败，请稍后重试')
        }
      } else {
        this.$message.error('下载文件地址不存在！')
      }
    },

    // 删除表单字段
    deleteFormItem(index) {
      this.$confirm('确定要删除此字段吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.sendData.splice(index, 1)
        this.$message.success('删除成功')
      }).catch(() => {
        // 取消删除
      })
    },

    // 时间段验证
    checkTimeRequired() {
      for (let index = 0; index < this.sendData.length; index++) {
        const element = this.sendData[index]
        // 时间段处理
        if (element.fieldType == 'period') {
          if (element.fieldParam.required && (!element.start || !element.end)) {
            const errorMsg = `${element.fieldName}为必填`
            this.$message.error(errorMsg)
            return false
          }
          if (element.start && element.end && typeof element.start === 'string' && typeof element.end === 'string') {
            const start = new Date(element.start.replace('年', '-').replace('月', ''))
            const end = new Date(element.end.replace('年', '-').replace('月', ''))
            if (end <= start) {
              const errorMsg = `${element.fieldName}结束时间须晚于开始时间`
              this.$message.error(errorMsg)
              return false
            }
            element.fieldContent = [element.start, element.end].join('-')
          }
        }
      }
      return true
    },

    checkTimeOrder() {
      const needCheckList = this.sendData.filter(
        (v) =>
          v.fieldType == 'period' &&
          v.fieldParam.setTimeOrder &&
          v.start &&
          v.end
      )
      if (needCheckList.length <= 1) return true

      for (let index = 1; index < needCheckList.length; index++) {
        // 后一项的开始时间需要晚于前一项的结束时间
        const currentItem = needCheckList[index]
        const prevItem = needCheckList[index - 1]
        if (currentItem.start && prevItem.end && typeof currentItem.start === 'string' && typeof prevItem.end === 'string') {
          const start = new Date(currentItem.start.replace('年', '-').replace('月', ''))
          const end = new Date(prevItem.end.replace('年', '-').replace('月', ''))
          if (start <= end) {
            const errorMsg = `${currentItem.fieldName}需晚于${prevItem.fieldName}`
            this.$message.error(errorMsg)
            return false
          }
        }
      }
      return true
    },

    // 表单提交
    async onSubmit() {
      // 同步formData到sendData，确保提交的是最新数据
      // 使用fieldId作为唯一标识，确保正确匹配字段
      this.sendData.forEach((item) => {
        if (['收件人手机号', '联系人手机号', '考生号', '身高', '体重'].includes(item.fieldName)) {
          // 直接同步，使用fieldId作为属性名，确保正确获取formData中的值
          const formFieldKey = 'field_' + item.fieldId;
          console.log(`同步字段 ${item.fieldName}，fieldId ${item.fieldId}，formFieldKey ${formFieldKey}，旧值 ${item.fieldContent}，新值 ${this.formData[formFieldKey]}`);
          item.fieldContent = this.formData[formFieldKey];
        }
      });

      // 打印同步后的数据，用于调试
      console.log('同步后的数据:', this.sendData);

      const timeRequireValid = this.checkTimeRequired()
      if (!timeRequireValid) {
        return
      }

      const timeOrderValid = this.checkTimeOrder()
      if (!timeOrderValid) {
        return
      }

      // 验证必传文件是否上传
      for (let index = 0; index < this.sendData.length; index++) {
        const element = this.sendData[index]
        const { fieldParam, fieldType, fieldName } = element
        if (fieldParam.required && this.isShow(element)) {
          if (
            element.fieldType.startsWith('upload') ||
            (element.fieldType == 'personInfo' &&
              ['艺考证', '一寸免冠照'].includes(element.fieldName))
          ) {
            if (!element.imgUrl || element.imgUrl.length === 0) {
              this.$message.error(`${fieldName}为必填`)
              return false
            }
          } else if (element.fieldType === 'subjectInfo') {
            // 验证subjectInfo类型字段的必填项
            if (!element.fieldProvinceName) {
              this.$message.error(`高考省份为必填`)
              return false
            }
            if (!element.fieldSubjectName) {
              this.$message.error(`省统考科类为必填`)
              return false
            }
            if (!element.fieldSubSubjectName) {
              this.$message.error(`省统考子科类为必填`)
              return false
            }
          } else if (element.fieldType === 'period') {
            // 时间段类型字段的必填项已经在checkTimeRequired中检查
          } else {
            if (
              Array.isArray(element.fieldContent) && element.fieldContent.length === 0 ||
              !Array.isArray(element.fieldContent) && !element.fieldContent
            ) {
              this.$message.error(`${fieldName}为必填`)
              return false
            }
          }
        }
      }

      // 校验手机号码和邮箱格式
      let isReturn = false;
      let errorMsg = '';
      for (let index = 0; index < this.sendData.length; index++) {
        const element = this.sendData[index];
        if (element.fieldContent && element.fieldType === "tel") {
          if (!/^[1]\d{10}$/.test(element.fieldContent)) {
            isReturn = true;
            errorMsg = `${element.fieldName}输入错误，请输入11位手机号码！`;
            break;
          }
        }
        // 校验邮箱
        if (element.fieldContent && element.fieldType === "email") {
          if (
              !/^[\w\u4e00-\u9fa5-]+(\.[\w\u4e00-\u9fa5-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(
                  element.fieldContent
              )
          ) {
            isReturn = true;
            errorMsg = `${element.fieldName}输入错误，请输入正确的邮箱格式！`;
            break;
          }
        }
      }
      if (isReturn) {
        this.$message.error(errorMsg);
        return false;
      }

      // 校验类型为text,personInfo,emial的fieldContent内容是否有相同的
      isReturn = false;
      errorMsg = '';

      for (let index = 0; index < this.sendData.length; index++) {
        const element = this.sendData[index];
        if (element.fieldContent && element.fieldParam.isCheckRepeat &&
            (['text', 'tel', 'email', 'radio', 'picker'].includes(element.fieldType)
                || ("personInfo" === element.fieldType
                    && ['收件人手机号', '联系人手机号', '身高', '体重', '考生号', '毕业中学', '收件人', '联系人', '姓名', '证件号码', '联系方式',].includes(element.fieldName)))) {
          const sameItem = this.sendData.filter(
              (v) => {
                if (v.fieldContent) {
                  return v.fieldContent == element.fieldContent;
                }
              }
          );
          console.log(sameItem, 'sameItem');
          if (sameItem && sameItem.length > 1) {
            isReturn = true;
            errorMsg = `"${element.fieldContent}"内容出现重复，请检查后提交！`;
            break;
          }
        }
      }
      if (isReturn) {
        this.$message.error(errorMsg);
        return false;
      }

      // 构建提交数据
      let result = []
      this.sendData.forEach((item) => {
        if (item.fieldType === 'subjectInfo') {
          // 生成新的对象
          let newObject1 = {
            ...item,
            fieldName: '高考省份',
            fieldContent: item.fieldProvinceName,
          }
          let newObject2 = {
            ...item,
            fieldName: '省统考科类',
            fieldContent: item.fieldSubjectName,
          }
          let newObject3 = {
            ...item,
            fieldName: '省统考子科类',
            fieldContent: item.fieldSubSubjectName,
          }
          result.push(newObject1, newObject2, newObject3)
        } else {
          let fieldContent = item.fieldContent
          if (item.fieldType === 'address' || (item.fieldType === 'personInfo' && item.fieldName === '通信地址')) {
            if (Array.isArray(item.fieldContent) && item.fieldContent.length > 0) {
              // 将Cascader组件的数组格式转换回后端期望的对象格式
              // 使用数组的最后一个元素作为areaCode（最里面层级的值）
              const areaCode = item.fieldContent[item.fieldContent.length - 1];

              // 尝试从areaTree中获取完整路径
              let path = '';
              // 根据字段类型选择正确的地址树
              const areaTree = (item.fieldType === 'personInfo' && item.fieldName === '通信地址') ? this.twoLevelAreaTree : this.areaTree;
              try {
                // 递归查找路径
                function findPath(node, code, currentPath) {
                  for (let n of node) {
                    if (n.value === code) {
                      return currentPath + n.label;
                    }
                    if (n.children && n.children.length > 0) {
                      let result = findPath(n.children, code, currentPath + n.label + '/');
                      if (result) {
                        return result;
                      }
                    }
                  }
                  return null;
                }

                path = findPath(areaTree, areaCode, '') || '';
              } catch (error) {
                console.log('获取地址路径失败', error);
              }

              // 确保提交格式正确
              fieldContent = {
                path: path,
                areaCode: areaCode
              };
            } else if (typeof item.fieldContent === 'string') {
              // 兼容字符串格式的地址
              fieldContent = {
                path: item.fieldContent,
                areaCode: ''
              };
            }
          } else if (item.fieldType === 'checkbox') {
            // checkbox类型数据提交时使用join连接
            if (Array.isArray(item.fieldContent)) {
              fieldContent = item.fieldContent.join('◆');
            }
          }
          result.push({
            fieldId: item.fieldId,
            fieldType: item.fieldType,
            fieldName: item.fieldName,
            fieldContent: fieldContent,
            imgUrl: item.imgUrl,
            fieldProvinceName: item.fieldProvinceName,
            fieldSubjectName: item.fieldSubjectName,
            fieldSubSubjectName: item.fieldSubSubjectName,
          })
        }
      })
      // 过滤掉有关联字段并且隐藏了的字段
      result = result.filter(s => this.isShow(s));
      const { collegeId, formConfigId, formId } = this
      const body = {
        collegeId,
        contentJson: JSON.stringify(result),
        formConfigId,
        formId,
        enrollId: this.$route.query.enrollId,
        branchId: this.$route.query.branchId,
        centerId: this.$route.query.centerId,
      }

      try {
        const res = await submitForm(body)
        if (res) {
          this.showConfirm()
        }
      } catch (error) {
        this.$message.error('提交失败，请稍后重试')
      }
    },

    showConfirm() {
      if (this.from == 'web-enroll') {
        this.$alert(
          `表单提交完成, 请点击页面左上方的 "返回专业报考"`,
          '提交成功',
          {
            confirmButtonText: '确定',
            showClose: false,
          },
        )
        return
      }

      const msg = this.isPc
        ? '请在报名前任务页面，确认该任务已完成！'
        : '请在手机上点击“我已提交”按钮，确认该任务已完成'
      this.$alert(msg, '提交成功', {
        confirmButtonText: '确定',
        showClose: false,
        callback: (action) => {
          this.$router.replace({ name: 'qrcode' })
        },
      })
    },

    // 获取消息信息
    async getmsgInfo() {
      try {
        const userInfo = this.userInfo.examinee;
        console.log(this.collegeJson, 'this.collegeJson');
        if (this.collegeJson && this.collegeJson.contentJson) {
          this.isAuditFieldValid = 0;
          let contentJson = JSON.parse(this.collegeJson.contentJson);
          this.sendData = this.sendData.map((v) => {
            let item = { ...v };
            contentJson.forEach((k) => {
              if (k.fieldId == v.fieldId) {
                // 时间段（年月）初始化为两个字段
                if (k.fieldType == "period" && k.fieldContent) {
                  const [start, end] = k.fieldContent.split("-");
                  if (start) {
                    item.start = start;
                  }
                  if (end) {
                    item.end = end;
                  }
                }

                if (k.fieldType == "checkbox") {
                  k.fieldContent =
                      (k.fieldContent && typeof k.fieldContent === 'string' ? k.fieldContent.split("◆") : k.fieldContent) || [];
                }
                if (k.fieldType == "subjectInfo") {
                  item.fieldProvinceName = k.fieldProvinceName;
                  item.disabled = k.fieldProvinceName ? true : false;
                  item.fieldSubjectName = k.fieldSubjectName;
                  item.fieldSubSubjectName = k.fieldSubSubjectName;
                }
                if (
                  k.fieldType == "personInfo" &&
                  [
                    "姓名",
                    "性别",
                    "出生年月",
                    "证件类型",
                    "证件号码",
                    "联系方式",
                    "报名省份",
                    "科类",
                  ].includes(k.fieldName)
                ) {
                  // 个人信息类型表单默认置灰不可修改
                  item.disabled = k.fieldContent ? true : false;
                }
                let processedFieldContent = k.fieldContent;
                if (((k.fieldType == "address") || (k.fieldType == "personInfo" && k.fieldName == "通信地址")) && k.fieldContent) {
                  if (typeof k.fieldContent === 'object' && k.fieldContent.areaCode) {
                    // 地址类型字段的特殊处理，将areaCode转换为Cascader组件可以识别的数组格式
                    const areaCode = k.fieldContent.areaCode;
                    // 根据字段类型选择正确的地址树
                    const areaTree = (k.fieldType == "personInfo" && k.fieldName == "通信地址") ? this.twoLevelAreaTree : this.areaTree;

                    console.log('处理地址回显:', areaCode, areaTree);

                    // 递归查找完整路径
                    function findFullPath(node, code, currentPath) {
                      for (let n of node) {
                        if (n.value === code) {
                          return currentPath.concat([n.value]);
                        }
                        if (n.children && n.children.length > 0) {
                          const result = findFullPath(n.children, code, currentPath.concat([n.value]));
                          if (result) {
                            return result;
                          }
                        }
                      }
                      return null;
                    }

                    try {
                      // 尝试从areaTree中获取完整路径
                      const fullPath = findFullPath(areaTree, areaCode, []);
                      console.log('查找完整路径结果:', fullPath);

                      if (fullPath && fullPath.length > 0) {
                        processedFieldContent = fullPath;
                      } else {
                        // 如果找不到完整路径，使用简化处理
                        processedFieldContent = [areaCode];
                        console.log('使用简化处理:', processedFieldContent);
                      }
                    } catch (error) {
                      console.log('获取地址完整路径失败', error);
                      // 出错时使用简化处理
                      processedFieldContent = [areaCode];
                    }
                  } else if (typeof k.fieldContent === 'string') {
                    // 兼容字符串格式的地址
                    processedFieldContent = k.fieldContent;
                  }
                }
                item = {
                  ...item,
                  fieldContent: processedFieldContent,
                  imgUrl: k.imgUrl,
                  start: item.start,
                  end: item.end,
                };
              }
            });
            return item;
          });
        } else {
          this.sendData = this.sendData.map((v) => {
            let item = { ...v };
            // 个人类型的表单，则需要把考生自己的个人信息带入表单
            if (v.fieldType == "personInfo") {
              if (v.fieldName == this.personArr[0].label) {
                v.imgUrl =
                  v.imgUrl && v.imgUrl.length
                    ? v.imgUrl
                    : userInfo.examEntranceLicence
                      ? [userInfo.examEntranceLicence]
                      : [];
              } else if (
                v.fieldName == this.personArr[1].label ||
                v.fieldName == "高考省份"
              ) {
                v.fieldContent = v.fieldContent
                  ? v.fieldContent
                  : userInfo.originLocationName
                    ? userInfo.originLocationName
                    : "";
              } else if (v.fieldName == this.personArr[2].label) {
                v.fieldContent = v.fieldContent
                  ? v.fieldContent
                  : userInfo.examineeNo
                    ? userInfo.examineeNo
                    : "";
              } else if (v.fieldName == this.personArr[3].label) {
                v.fieldContent = v.fieldContent
                  ? v.fieldContent
                  : userInfo.majorType
                    ? this.subjectTypeList[userInfo.majorType - 1]
                    : "";
              } else if (v.fieldName == this.personArr[4].label) {
                v.fieldContent = v.fieldContent
                  ? v.fieldContent
                  : userInfo.graduateSchool
                    ? userInfo.graduateSchool
                    : "";
              } else if (v.fieldName == this.personArr[5].label) {
                v.imgUrl =
                  v.imgUrl && v.imgUrl.length
                    ? v.imgUrl
                    : userInfo.officialPhoto
                      ? [userInfo.officialPhoto]
                      : [];
              } else if (v.fieldName == this.personArr[6].label) {
                v.fieldContent = v.fieldContent
                  ? v.fieldContent
                  : userInfo.height
                    ? userInfo.height
                    : "";
              } else if (v.fieldName == this.personArr[7].label) {
                v.fieldContent = v.fieldContent
                  ? v.fieldContent
                  : userInfo.weight
                    ? userInfo.weight
                    : "";
              } else if (v.fieldName == this.personArr[8].label) {
                v.fieldContent = v.fieldContent
                  ? v.fieldContent
                  : userInfo.recipientProvinceName
                    ? userInfo.recipientProvinceName + (userInfo.recipientCityName ? '/' + userInfo.recipientCityName : '')
                    : "";
              } else if (v.fieldName == this.personArr[9].label) {
                v.fieldContent = v.fieldContent
                  ? v.fieldContent
                  : userInfo.recipientAddress
                    ? userInfo.recipientAddress
                    : "";
              } else if (v.fieldName == this.personArr[10].label) {
                v.fieldContent = v.fieldContent
                  ? v.fieldContent
                  : userInfo.recipientName
                    ? userInfo.recipientName
                    : "";
              } else if (v.fieldName == this.personArr[11].label) {
                v.fieldContent = v.fieldContent
                  ? v.fieldContent
                  : userInfo.recipientTelephone
                    ? userInfo.recipientTelephone
                    : "";
              } else if (v.fieldName == this.personArr[12].label) {
                v.fieldContent = v.fieldContent
                  ? v.fieldContent
                  : userInfo.contactPerson
                    ? userInfo.contactPerson
                    : "";
              } else if (v.fieldName == this.personArr[13].label) {
                v.fieldContent = v.fieldContent
                  ? v.fieldContent
                  : userInfo.contactPhoneNumber
                    ? userInfo.contactPhoneNumber
                    : "";
              } else if (v.fieldName == this.personArr[14].label) {
                v.fieldContent = v.fieldContent
                  ? v.fieldContent
                  : userInfo.examineeName
                    ? userInfo.examineeName
                    : "";
              } else if (v.fieldName == this.personArr[15].label) {
                v.fieldContent = v.fieldContent
                  ? v.fieldContent
                  : userInfo.examineeSex === 0
                    ? "女"
                    : userInfo.examineeSex === 1
                      ? "男"
                      : "";
              } else if (v.fieldName == this.personArr[16].label) {
                v.fieldContent = v.fieldContent
                  ? v.fieldContent
                  : userInfo.birthday
                    ? userInfo.birthday
                    : "";
              } else if (v.fieldName == this.personArr[17].label) {
                v.fieldContent = v.fieldContent
                  ? v.fieldContent
                  : userInfo.idType || userInfo.idType == 0
                    ? this.iDTypeList[userInfo.idType - 1]
                    : "";
              } else if (v.fieldName == this.personArr[18].label) {
                v.fieldContent = v.fieldContent
                  ? v.fieldContent
                  : userInfo.examineeIdNo
                    ? userInfo.examineeIdNo
                    : "";
              } else if (v.fieldName == this.personArr[19].label) {
                if (this.userInfo.isOverseas == 0) {
                  v.fieldContent = v.fieldContent
                    ? v.fieldContent
                    : userInfo.examineePhoneNumber
                      ? userInfo.examineePhoneNumber
                      : "";
                } else if (this.userInfo.isOverseas == 1) {
                  v.fieldContent = v.fieldContent
                    ? v.fieldContent
                    : this.userInfo.email
                      ? this.userInfo.email
                      : "";
                }
              }
              if (
                [
                  "姓名",
                  "性别",
                  "出生年月",
                  "证件类型",
                  "证件号码",
                  "联系方式",
                  "报名省份",
                  "科类",
                ].includes(v.fieldName)
              ) {
                item.disabled = v.fieldContent ? true : false;
              }
              item = {
                ...item,
                fieldContent: v.fieldContent,
                imgUrl: v.imgUrl,
              };
            }
            return item;
          });
        }
        for (let index = 0; index < this.sendData.length; index++) {
          const element = this.sendData[index];
          if (element.imgUrl && element.imgUrl.length) {
            element.imgUrl = element.imgUrl.filter((v) => v);
            // 确保uploadParam存在
            element.uploadParam = element.uploadParam || {
              fileList: [],
              maxCount: element.uploadParam?.maxCount || 100,
              accept: element.uploadParam?.accept || 'image/*',
              maxSize: element.uploadParam?.maxSize || 3,
            };

            // 重新构建完整的fileList，保留文件名等信息
            const fileList = [];
            for (let jndex = 0; jndex < element.imgUrl.length; jndex++) {
              const url = element.imgUrl[jndex];
              const res = await getRealUrl(url);
              fileList.push({
                uid: jndex,
                name: fileNamebyUrl(url),
                url: res,
                status: 'success',
              });
            }

            // 完整替换fileList，而不是部分修改
            this.sendData[index].uploadParam.fileList = fileList;
          }
        }
        console.log(this.sendData);

        // 同步sendData到formData，确保页面正确回显
        this.sendData.forEach((item) => {
          if (['收件人手机号', '联系人手机号', '考生号', '身高', '体重'].includes(item.fieldName)) {
            // 使用Vue.set确保属性是响应式的，使用fieldId作为属性名
            this.$set(this.formData, `field_${item.fieldId}`, item.fieldContent);
          }
        });

        setTimeout(() => {
          this.reflesh = false;
        }, 500);
      } catch (error) {
        console.error('getmsgInfo error:', error);
      } finally {
        // this.reflesh = false;
      }
    },

    // 数据初始化
    async getData() {
      const res = await getFormInfo(this.formConfigId)
      const {
        contentJson,
        initJson,
        collegeId,
        formId,
        collegeName,
        formName,
        isModifiable,
        initJsonRel,
      } = res
      this.collegeId = collegeId
      this.formId = formId
      this.collegeName = collegeName
      this.formName = formName
      this.isModifiable = isModifiable
      this.collegeJson = res
      this.relateList = JSON.parse(initJsonRel || '[]')

      // 处理表单数据
      await this.getInitData(initJson, contentJson)
    },

    async getInitData(initJson, contentJson) {
      const userInfo = this.userInfo.examinee
      const msgData = JSON.parse(initJson)

      // 初始化个人信息字段
      msgData.forEach((v) => {
        if (v.fieldType == 'personInfo') {
          if (
            v.fieldName == '报名省份' ||
            v.fieldName == '科类' ||
            v.fieldName == '证件类型' ||
            v.fieldName == '性别'
          ) {
            v.fieldParam.showPicker = false
          } else if (v.fieldName == '艺考证' || v.fieldName == '一寸免冠照') {
            v.uploadParam = {
              fileList: [],
            }
            v.imgUrl = []
          }
        }
        // 个人信息类型，优先显示填写的信息，其次考生认证的信息，否则显示空
        if (v.fieldType == 'subjectInfo') {
          // 台湾 710000 香港 810000 澳门 820000 990000华侨，999999导入名单港澳台侨
          if (
            ["710000", "810000", "820000", "990000", "999999"].includes(
              userInfo.originLocationCode
            )
          ) {
            v.fieldProvinceName = "港澳台侨";
          } else if (["000000"].includes(userInfo.originLocationCode)) {
            v.fieldProvinceName = "国际";
          } else {
            v.fieldProvinceName = userInfo.originLocationName
              ? userInfo.originLocationName
              : "";
          }
        }
        // 附件类型fieldContent赋值
        if (v.fieldType == 'attachment') {
          v.fieldContent = v.attachmentUrl
        }
      })

      this.sendData = msgData

      // 处理文件列表
      for (let i = 0; i < this.sendData.length; i++) {
        const item = this.sendData[i]
        if (['uploadImg', 'uploadVideo', 'uploadPDF', 'uploadAudio'].includes(item.fieldType) ||
          (item.fieldType == 'personInfo' && ['艺考证', '一寸免冠照'].includes(item.fieldName))) {
          item.uploadParam = item.uploadParam || {
            fileList: [],
            maxCount: item.uploadParam?.maxCount || 100,
            accept: item.uploadParam?.accept || 'image/*',
            maxSize: item.uploadParam?.maxSize || 3,
          }
          item.imgUrl = item.imgUrl || []

          // 处理文件列表
          if (item.imgUrl.length) {
            const fileList = []
            for (let j = 0; j < item.imgUrl.length; j++) {
              const url = await getRealUrl(item.imgUrl[j])
              fileList.push({
                uid: j,
                name: fileNamebyUrl(item.imgUrl[j]),
                url: url,
                status: 'success',
              })
            }
            item.uploadParam.fileList = fileList
          }
        }
      }

      // 获取地址树数据（3层，用于普通地址组件）
      await this.getAreaTree()

      // 获取2层地区数据（用于通信地址组件）
      await this.getTwoLevelAreaData()

      // 获取省份列表
      await this.getProvince()

      // 获取专业列表（用于科目选择）
      await this.getVarietyList()

      // 处理已有数据
      if (contentJson) {
        const content = JSON.parse(contentJson)
        this.sendData = this.sendData.map((v) => {
          let item = { ...v }
          const contentItem = content.find((k) => k.fieldId == v.fieldId)
          if (contentItem) {
            item.fieldContent = contentItem.fieldContent
            item.imgUrl = contentItem.imgUrl || []
            item.fieldProvinceName = contentItem.fieldProvinceName
            item.fieldSubjectName = contentItem.fieldSubjectName
            item.fieldSubSubjectName = contentItem.fieldSubSubjectName
            if (contentItem.fieldType == 'time') {
              item.fieldContent = new Date(contentItem.fieldContent)
            } else if ((contentItem.fieldType == 'personInfo' && contentItem.fieldName == '通信地址') || contentItem.fieldType == 'address') {
              // 处理地址类型的回显，确保fieldContent是数组格式
              let areaCode = ''
              if (typeof contentItem.fieldContent === 'object' && contentItem.fieldContent !== null) {
                // 如果是对象格式，获取areaCode
                areaCode = contentItem.fieldContent.areaCode || ''
              } else if (typeof contentItem.fieldContent === 'string') {
                // 如果是字符串格式，暂时使用空areaCode
                areaCode = ''
              }

              // 尝试从地址树中获取完整路径数组
              let pathArray = []
              // 根据字段类型选择正确的地址树
              const areaTree = (contentItem.fieldType == 'personInfo' && contentItem.fieldName == '通信地址') ? this.twoLevelAreaTree : this.areaTree
              try {
                function findPathArray(node, code, currentPath) {
                  for (let n of node) {
                    if (n.value === code) {
                      return [...currentPath, n.value]
                    }
                    if (n.children && n.children.length > 0) {
                      let result = findPathArray(n.children, code, [...currentPath, n.value])
                      if (result) {
                        return result
                      }
                    }
                  }
                  return null
                }

                pathArray = findPathArray(areaTree, areaCode, []) || []
                // 如果找不到路径但有areaCode，直接使用areaCode作为路径数组
                if (pathArray.length === 0 && areaCode) {
                  pathArray = [areaCode]
                }
              } catch (error) {
                console.log('获取地址路径数组失败', error)
                // 出错时如果有areaCode，直接使用areaCode作为路径数组
                if (areaCode) {
                  pathArray = [areaCode]
                }
              }

              // 确保fieldContent是数组格式
              item.fieldContent = pathArray
            } else if (contentItem.fieldType == 'personInfo' && contentItem.fieldName == '出生年月') {
              // 处理出生年月字段，确保YYYYMMDD格式的字符串能够被el-date-picker正确识别
              if (typeof contentItem.fieldContent === 'string' && /^\d{8}$/.test(contentItem.fieldContent)) {
                // 如果是YYYYMMDD格式的字符串，保持不变，el-date-picker会自动识别
                item.fieldContent = contentItem.fieldContent
              }
            }
          }
          return item
        })
      }

      this.sendData = this.sendData.map((v) => {
        if (v.fieldType == 'personInfo') {
          if (v.fieldName == this.personArr[0].label) {
            v.imgUrl = v.imgUrl && v.imgUrl.length ? v.imgUrl : userInfo.examEntranceLicence ? [userInfo.examEntranceLicence] : []
          } else if (v.fieldName == this.personArr[1].label || v.fieldName == '高考省份') {
            v.fieldContent = v.fieldContent ? v.fieldContent : userInfo.originLocationName ? userInfo.originLocationName : ''
          } else if (v.fieldName == this.personArr[2].label) {
            v.fieldContent = v.fieldContent ? v.fieldContent : userInfo.examineeNo ? userInfo.examineeNo : ''
          } else if (v.fieldName == this.personArr[3].label) {
            v.fieldContent = v.fieldContent ? v.fieldContent : userInfo.majorType ? this.subjectTypeList[userInfo.majorType - 1] : ''
          } else if (v.fieldName == this.personArr[4].label) {
            v.fieldContent = v.fieldContent ? v.fieldContent : userInfo.graduateSchool ? userInfo.graduateSchool : ''
          } else if (v.fieldName == this.personArr[5].label) {
            v.imgUrl = v.imgUrl && v.imgUrl.length ? v.imgUrl : userInfo.officialPhoto ? [userInfo.officialPhoto] : []
          } else if (v.fieldName == this.personArr[6].label) {
            v.fieldContent = v.fieldContent ? v.fieldContent : userInfo.height ? userInfo.height : ''
          } else if (v.fieldName == this.personArr[7].label) {
            v.fieldContent = v.fieldContent ? v.fieldContent : userInfo.weight ? userInfo.weight : ''
          } else if (v.fieldName == this.personArr[8].label) {
            if (v.fieldContent) {
              // 如果已有数据，保持不变
            } else if (userInfo.recipientProvinceName) {
              // 使用用户信息构建通信地址
              const provinceName = userInfo.recipientProvinceName
              const cityName = userInfo.recipientCityName

              // 尝试从twoLevelAreaTree中获取对应的areaCode
              let pathArray = []
              try {
                function findAreaCode(node, province, city) {
                  for (let n of node) {
                    if (n.label === province) {
                      pathArray.push(n.value)
                      if (city && n.children) {
                        for (let child of n.children) {
                          if (child.label === city) {
                            pathArray.push(child.value)
                            return true
                          }
                        }
                      }
                      return true
                    }
                  }
                  return false
                }

                findAreaCode(this.twoLevelAreaTree, provinceName, cityName)
              } catch (error) {
                console.log('获取通信地址areaCode失败', error)
              }

              if (pathArray.length > 0) {
                v.fieldContent = pathArray
              } else {
                // 如果找不到对应的areaCode，使用字符串格式
                v.fieldContent = provinceName + (cityName ? '/' + cityName : '')
              }
            } else {
              v.fieldContent = ''
            }
          } else if (v.fieldName == this.personArr[9].label) {
            v.fieldContent = v.fieldContent ? v.fieldContent : userInfo.recipientAddress ? userInfo.recipientAddress : ''
          } else if (v.fieldName == this.personArr[10].label) {
            v.fieldContent = v.fieldContent ? v.fieldContent : userInfo.recipientName ? userInfo.recipientName : ''
          } else if (v.fieldName == this.personArr[11].label) {
            v.fieldContent = v.fieldContent ? v.fieldContent : userInfo.recipientTelephone ? userInfo.recipientTelephone : ''
          } else if (v.fieldName == this.personArr[12].label) {
            v.fieldContent = v.fieldContent ? v.fieldContent : userInfo.contactPerson ? userInfo.contactPerson : ''
          } else if (v.fieldName == this.personArr[13].label) {
            v.fieldContent = v.fieldContent ? v.fieldContent : userInfo.contactPhoneNumber ? userInfo.contactPhoneNumber : ''
          } else if (v.fieldName == this.personArr[14].label) {
            v.fieldContent = v.fieldContent ? v.fieldContent : userInfo.examineeName ? userInfo.examineeName : ''
          } else if (v.fieldName == this.personArr[15].label) {
            v.fieldContent = v.fieldContent ? v.fieldContent : userInfo.examineeSex === 0 ? '女' : userInfo.examineeSex === 1 ? '男' : ''
          } else if (v.fieldName == this.personArr[16].label) {
            v.fieldContent = v.fieldContent ? v.fieldContent : userInfo.birthday ? userInfo.birthday : ''
          } else if (v.fieldName == this.personArr[17].label) {
            v.fieldContent = v.fieldContent ? v.fieldContent : userInfo.idType || userInfo.idType == 0 ? this.iDTypeList[userInfo.idType - 1] : ''
          } else if (v.fieldName == this.personArr[18].label) {
            v.fieldContent = v.fieldContent ? v.fieldContent : userInfo.examineeIdNo ? userInfo.examineeIdNo : ''
          } else if (v.fieldName == this.personArr[19].label) {
            if (this.userInfo.isOverseas == 0) {
              v.fieldContent = v.fieldContent ? v.fieldContent : userInfo.examineePhoneNumber ? userInfo.examineePhoneNumber : ''
            } else if (this.userInfo.isOverseas == 1) {
              v.fieldContent = v.fieldContent ? v.fieldContent : this.userInfo.email ? this.userInfo.email : ''
            }
          }
        }
        return v
      })

      // 处理回复内容和审核状态
      if (
        this.collegeJson.replyContent
      ) {
        this.showReasonBox(this.collegeJson.replyContent);
      } else if (this.collegeJson.auditStatus == 3 && this.collegeJson.auditMessage) {
        this.showReasonBox(this.collegeJson.auditMessage);
      } else if (this.collegeJson.auditStatus == 2 && this.collegeJson.auditMessage) {
        this.showReasonBox(this.collegeJson.auditMessage);
      } else if (
        this.collegeJson.modificationProhibitedReason
      ) {
        this.showReasonBox(this.collegeJson.modificationProhibitedReason);
      }

      // 初始化subjectInfo类型字段的下拉框数据
      this.sendData.forEach((v, index) => {
        if (v.fieldType == 'subjectInfo') {
          // 初始化省份对应的科目列表
          this.chooseSubject(index, 1)
        }
      })
    },

    async getProvince() {
      // 这里需要根据实际API获取省份列表
      this.provinceList = await getAreaList()
    },

    async getVarietyList() {
      // 这里需要根据实际API获取专业列表
      this.varietyList = await getVarietyList()
    },

    async getCurrentUserInfo() {
      const token = this.$route.query.token;
      this.userInfo = await getUserInfoByToken({ token: token });
      if (this.userInfo.examinee && this.userInfo.examinee.idCardUrlFront) {
        // const process = "image/resize,w_2000,h_2000,m_lfit";
        this.userInfo.examinee.idCardUrlFront = await getRealUrl(
          this.userInfo.examinee.idCardUrlFront,
        );
      }
    },

    // 获取地址树数据（3层）
    async getAreaTree() {
      try {
        this.areaLoading = true
        const res = await getAreaTree()
        if (res) {
          // 将地址树数据转换为Cascader所需的格式
          this.areaTree = this.transformAreaTree(res)
        }
      } catch (error) {
        console.log('获取地址树失败', error)
      } finally {
        this.areaLoading = false
      }
    },

    // 获取2层地区数据
    async getTwoLevelAreaData() {
      try {
        this.areaLoading = true
        const res = await getCityAreaList()
        if (res) {
          // 生成只包含2层的地址树数据
          this.twoLevelAreaTree = this.transformTwoLevelAreaTree(res)

          // 重新处理通信地址的回显
          this.sendData = this.sendData.map((v) => {
            if (v.fieldType == 'personInfo' && v.fieldName == '通信地址') {
              if (typeof v.fieldContent === 'string' && v.fieldContent) {
                // 如果是字符串格式的地址，尝试转换为数组格式
                const pathParts = v.fieldContent.split('/')
                if (pathParts.length > 0) {
                  let pathArray = []
                  try {
                    function findAreaCode(node, province, city) {
                      for (let n of node) {
                        if (n.label === province) {
                          pathArray.push(n.value)
                          if (city && n.children) {
                            for (let child of n.children) {
                              if (child.label === city) {
                                pathArray.push(child.value)
                                return true
                              }
                            }
                          }
                          return true
                        }
                      }
                      return false
                    }

                    findAreaCode(this.twoLevelAreaTree, pathParts[0], pathParts[1])
                  } catch (error) {
                    console.log('获取通信地址areaCode失败', error)
                  }

                  if (pathArray.length > 0) {
                    v.fieldContent = pathArray
                  }
                }
              }
            }
            return v
          })
        }
      } catch (error) {
        console.log('获取2层地区数据失败', error)
      } finally {
        this.areaLoading = false
      }
    },

    // 转换为只包含2层的地址树数据格式
    transformTwoLevelAreaTree(data) {
      if (!Array.isArray(data)) {
        return []
      }
      return data.map(item => {
        const transformedItem = {
          value: item.areaCode,
          label: item.areaName
        }
        // 只处理第一级的subAreaList，不递归处理更深层级
        const childNodes = item.subAreaList;
        if (childNodes && Array.isArray(childNodes) && childNodes.length > 0) {
          transformedItem.children = childNodes.map(child => ({
            value: child.areaCode,
            label: child.areaName
          }))
        }

        return transformedItem
      })
    },

    // 转换地址树数据格式
    transformAreaTree(data) {
      if (!Array.isArray(data)) {
        return []
      }
      return data.map(item => {
        const transformedItem = {
          value: item.areaCode,
          label: item.areaName
        }
        // 递归处理children数据，只有当存在子节点时才添加children属性
        // 支持三种字段名：subAreaList、childList 和 children
        const childNodes = item.subAreaList || item.childList || item.children;
        if (childNodes && Array.isArray(childNodes) && childNodes.length > 0) {
          transformedItem.children = this.transformAreaTree(childNodes)
        }

        return transformedItem
      })
    },

    showReasonBox(msg) {
      this.$alert(msg, '', {
        confirmButtonText: '确定',
        callback: action => {
          // on close
        }
      });
    },

    // 处理表单提交
    async submitForm() {
      try {
        // 触发表单验证
        this.$refs.form.validate((valid) => {
          if (valid) {
            // 打印formData的值，用于调试
            console.log('formData的值:', this.formData);

            // 同步formData到sendData
            // 使用fieldId作为唯一标识，确保正确匹配字段
            this.sendData.forEach((item) => {
              if (['收件人手机号', '联系人手机号', '考生号', '身高', '体重'].includes(item.fieldName)) {
                // 直接同步，使用fieldId作为属性名，确保正确获取formData中的值
                const formFieldKey = 'field_' + item.fieldId;
                console.log(`同步字段 ${item.fieldName}，fieldId ${item.fieldId}，formFieldKey ${formFieldKey}，旧值 ${item.fieldContent}，新值 ${this.formData[formFieldKey]}`);
                item.fieldContent = this.formData[formFieldKey];
              }
            });

            // 打印同步后的数据，用于调试
            console.log('同步后的数据:', this.sendData);

            // 这里需要根据实际API处理表单提交
            console.log('Form submitted:', this.sendData);
          } else {
            console.log('Form validation failed');
            return false;
          }
        });
      } catch (error) {
        console.error('submitForm error:', error);
      }
    },

    // 校验手机号
    validatorPhone(rule, value, callback) {
      if (!value) {
        callback();
      } else if (!/^[1]\d{10}$/.test(value)) {
        callback(new Error('请输入正确手机号'));
      } else {
        callback();
      }
    },

    // 校验18位以内纯数字
    validator1to18(rule, value, callback) {
      if (!value) {
        callback();
      } else if (!/^\d{1,18}$/.test(value)) {
        callback(new Error('18位以内纯数字'));
      } else {
        callback();
      }
    },

    // 校验50-300的数字
    validator50to300(rule, value, callback) {
      if (!value) {
        callback();
      } else if (!/^(?:[5-9]\d|[1-2]\d{2}|300)$/.test(value)) {
        callback(new Error('50-300的数字'));
      } else {
        callback();
      }
    },

    // 校验1-999的数字
    validator1to999(rule, value, callback) {
      if (!value) {
        callback();
      } else if (!/^(?:[1-9]|[1-9]\d{1,2}|999)$/.test(value)) {
        callback(new Error('1-999的数字'));
      } else {
        callback();
      }
    },
  },
}
</script>

<style>
.wrapper {
  background: #ffffff;
  box-shadow: 0px 0px 48px rgba(0, 0, 0, 0.06);
  border-radius: 20px;
  margin: 20px auto;
  max-width: 800px;
  width: 80%;
  min-height: 90vh;
  padding: 30px 90px;
  box-sizing: border-box;
}

.title {
  text-align: center;
  font-size: 28px;
}

.tip {
  text-align: center;
  color: #7d7e82;
  font-size: 16px;
  margin: 5px 0 15px;
}

.bottom {
  display: flex;
  justify-content: center;
}

.btn {
  width: 120px;
}

.btn-cancel {
  margin-right: 40px;
}

.form{
  max-height: 73vh;
  overflow-y: auto;
}

.form>>>.el-select {
  width: 100%;
}

.form>>>.el-textarea__inner,
.form>>>.el-input__inner {
  border: 1px solid #e3e3e3;
}

.form>>>.el-divider {
  background-color: #e3e3e3;
}

.form>>>.el-form-item__label {
  font-weight: bold;
  line-height: normal!important;
}

.form>>>.el-checkbox {
  line-height: 1;
}

.form>>>.el-checkbox__input {
  line-height: 23px;
  vertical-align: top;
}

.form>>>.el-checkbox__label {
  white-space: normal;
}

.isRequired {
  color: #f56c6c;
  margin-right: 4px;
}

.color1 {
  color: #9fa4b4;
  font-weight: 400;
  padding: 0 0px;
  font-size: 12px;
  text-align: left;
  font-family: PingFang SC, PingFang SC;
}

/* 表单字段容器样式 */
.form-item-container {
  position: relative;
  margin-bottom: 20px;
  padding-right: 30px;
}

/* 删除按钮样式 */
.delete-button {
  position: absolute;
  top: 0;
  right: 0;
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  color: #999;
  cursor: pointer;
  border-radius: 50%;
  transition: all 0.3s;
}

.delete-button:hover {
  background-color: #f56c6c;
  color: #fff;
}

.delete-button i {
  font-size: 16px;
}

/* 控制上传按钮的显示和隐藏 */
.hide-upload-btn >>> .el-upload--picture-card,
.hide-upload-btn >>> .el-upload__trigger {
  display: none !important;
}

.custom-address-popper .el-cascader-panel {
  max-height: 400px;
  overflow-y: auto;
}

.custom-address-popper .el-scrollbar__wrap {
  overflow-x: hidden;
}
</style>
